import React from 'react';
import type { AddPvdConfigRequest } from '@/../generated-client/models';
import { PvdConfigModalBase } from './PvdConfigModalBase';
import { createDefaultPvdConfig } from './utils/defaultPvdConfig';

interface Props {
  show: boolean;
  onHide: () => void;
  onCreate: (config: AddPvdConfigRequest) => void;
  locked?: boolean;
}

export const CreatePvdConfigModal: React.FC<Props> = ({ show, onHide, onCreate, locked }) => {
  const defaultConfig = createDefaultPvdConfig();
  return (
    <PvdConfigModalBase
      show={show}
      onHide={onHide}
      config={defaultConfig}
      onSave={onCreate}
      mode="create"
      locked={locked}
    />
  );
};
